// extracted by mini-css-extract-plugin
export default {"cont":"EndNode_cont__PwU7a","details":"EndNode_details__AmRtT","placeholder":"EndNode_placeholder__ZIQ5y","text":"EndNode_text__4442S"};